export const TYPES_DATA_USER = {
  EMAIL: 'email',
  NAME: 'name',
  PASSWORD: 'password',
  SURNAMES: 'surnames',
  USERNAME: 'username',
}

export const TYPES_USER_ROLES = {
  ADMIN: 'ADMIN',
  RELATIVE: 'RELATIVE',
  STUDENT: 'STUDENT',
  STUDENT_UNDER_14: 'STUDENT_UNDER_14',
  TEACHER: 'TEACHER',
}

export const TYPES_USER_BOOK_STATUS = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  DELETED: 'DELETED',
  EXPIRED: 'EXPIRED',
  HIDDEN: 'HIDDEN',
  INACTIVE: 'INACTIVE',
}

export const TYPES_STATUS = {
  CREATED: 'CREATED',
  DELETED: 'DELETED',
  HIDDEN: 'HIDDEN',
}

export const TYPES_USER_STATUS = {
  PENDING_VERIFY: 'PENDING_VERIFY',
  VERIFIED: 'VERIFIED',
}

export const TYPES_COUNTRIES = {
  CR: 'CR',
  ES: 'ES',
}

export const TYPE_FEEDBACKS_ACTIONS = {
  POOL_LATER: 'POOL_LATER',
  POOL_STARTED: 'POOL_STARTED',
}

export const TYPES_PUBLISHERS = {
  VICENS_VIVES: 'Vicens Vives',
}

export const TYPE_VALIDATION_STATUS = {
  INVALIDATED: 'INVALIDATED',
  PENDING: 'PENDING',
  REFUSED: 'REFUSED',
  VALIDATED: 'VALIDATED',
}

export const HIDDEN_PASSWORD_USER = '************'

export const FIELDS_ID_USER_PROFILE = {
  BIRTHDATE: 'BIRTHDATE',
  BIRTHDATE_UNDER: 'BIRTHDATE_UNDER',
  EMAIL: 'EMAIL',
  LOCALE: 'LOCALE',
  NAME: 'NAME',
  NIN: 'NIN',
  PASSWORD: 'PASSWORD',
  PROMOTIONS_TERMS: 'PROMOTIONS_TERMS',
  SCHOOL: 'SCHOOL',
  SURNAMES: 'SURNAMES',
  USERNAME: 'USERNAME',
}
